module.exports = __webpack_public_path__ + "media/images/about/time/6-6ad26b4f5081b424aced6b8ef7384e89.png";